export const BASE_PATH = 'notes';

export const FOLLOW_UP_PATH = `follow-ups`;

export const INSIGHTS_PATH = `insights`;
